import { getCookie } from '@/utils/cookie';
import { parseJson } from '@/utils/json';

let controller = null;

export const aiAbort = () => {
    if (controller) {
        controller.abort();
        controller = null;
    }
};

export const aiAsk = (asst, prompt, issue, temperature, resolve, done) => {
    let host = window.location.hostname;
    if (host.indexOf('admin.haobangyang.cc') >= 0) {
        host = '';
    } else {
        host = 'http://' + host + ':8090';
    }

    const url = host + `/sa/ai/completion?service_token=` + getCookie();
    const models = {
        gpt: 'gpt-3.5-turbo-0125', // gpt-3.5-turbo-0125
        ernie: 'v4',
        chatglm: 'glm-3-turbo',
        gemini: 'gemini-pro',
    };
    const body = {
        engine: asst,
        model: models[asst] || '',
        prompt,
        temperature: parseFloat(temperature),
        messages: [
            {
                role: 'user',
                content: issue,
            },
        ],
    };

    controller = new AbortController();
    const signal = controller.signal;
    fetch(url, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(body),
        signal,
    })
        .then(response => {
            if (!response.body) {
                throw { code: 'error', message: 'not stream' };
            }

            const reader = response.body.getReader();
            const processChunk = () => {
                return reader.read().then(read => {
                    if (read.done) {
                        throw { code: 200, message: '' };
                    }
                    const text = new TextDecoder().decode(read.value);
                    const chunks = text.split('\n').filter(Boolean);
                    chunks.forEach(chunk => {
                        const data = chunk.startsWith('data:') ? chunk.substring(5) : chunk;
                        if (data.length == 0) {
                            return;
                        }
                        if (data == '[DONE]') {
                            throw { code: 200, message: '' };
                        }
                        const res = parseJson(data);
                        if (!res) {
                            return;
                        }
                        if (res.code != 200) {
                            throw res;
                        }
                        resolve(res);
                    });

                    return processChunk();
                });
            };

            return processChunk();
        })
        .catch(res => {
            if (signal.aborted) {
                done();
            } else {
                done(res);
            }
        });
};
